export default __webpack_public_path__ + "static/media/misc-closetA-768w.e12f7ffb.avif";